"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addQueryParamsToImageUrl = addQueryParamsToImageUrl;
const QUERY_STRIPPER = /\?.*$/;
function addQueryParamsToImageUrl(source, params, options) {
    if (!source) {
        throw new Error('Image URL source is required');
    }
    const replaceExistingSearch = options?.replaceExistingSearch ?? true;
    const normalizedSource = replaceExistingSearch
        ? source.replace(QUERY_STRIPPER, '')
        : source;
    const url = new URL(normalizedSource);
    const quality = params?.quality;
    if (quality !== undefined && quality !== null) {
        const pathSegments = url.pathname.split('/').filter(Boolean);
        const filteredSegments = pathSegments.filter(segment => !segment.startsWith('filters:quality('));
        const normalizedPath = filteredSegments.join('/');
        const qualityFilterSegment = `filters:quality(${String(quality)})`;
        url.pathname = normalizedPath
            ? `/${qualityFilterSegment}/${normalizedPath}`
            : `/${qualityFilterSegment}`;
    }
    if (replaceExistingSearch) {
        url.search = '';
    }
    if (params) {
        Object.entries(params).forEach(([key, value]) => {
            if (key === 'quality') {
                return;
            }
            if (value === undefined || value === null) {
                url.searchParams.delete(key);
            }
            else {
                url.searchParams.set(key, String(value));
            }
        });
    }
    const queryString = url.searchParams.toString();
    url.search = queryString ? `?${queryString}` : '';
    return url.toString();
}
